export default __webpack_public_path__ + "static/media/artemest-round.1f442f38.svg";